import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { CardComponent } from '../card/card.component';
 
@Component({
    selector: 'card-product-small',
    templateUrl: './card-product-small.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CardProductSmallComponent extends CardComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    this.equalizeHeaderHeights();
  }
 
  private equalizeHeaderHeights(): void {
    setTimeout(() => {
      const headers = [...document.querySelectorAll('card-product-small h3, .card-product-small h3')];
      let maxHeight = 56;
      headers.forEach(el => {
        (el as HTMLElement).style.height = 'auto';
      });
      headers.forEach(el => {
        maxHeight = Math.max(maxHeight, (el as HTMLElement).scrollHeight);
      });
      headers.forEach(el => {
        (el as HTMLElement).style.height = maxHeight + 'px';
      });
    }, 0);
  }
}
 
 